export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    perfil_id: [1, 2, 6, 7], // Ambos os perfis têm acesso ao home
  },
  {
    title: 'Cadastros',
    icon: 'FileTextIcon',
    perfil_id: [1, 6, 7],
    children: [
      {
        title: 'Empresas',
        route: 'list-companies',
        perfil_id: [1],
      },
      {
        title: 'Unidades',
        route: 'list-units',
        perfil_id: [1, 6, 7],
      },
      {
        title: 'Usuários',
        route: 'list-users',
        perfil_id: [1, 6, 7],
      },
      {
        title: 'Perfis de Usuários',
        route: 'list-perfil-usuario',
        perfil_id: [1],
      },
      {
        title: 'Grupos',
        route: 'list-groups',
        perfil_id: [1, 6, 7],
      },
      {
        title: 'Checklists',
        route: 'list-checklisttemplates',
        perfil_id: [1, 6, 7],
      },
      {
        title: 'Agendamentos',
        route: 'list-checklistschedules',
        perfil_id: [1, 6, 7],
      },
      // {
      //   title: 'Grupos Checklists',
      //   route: 'list-groupchecklists',
      //   perfil_id: [1],
      // },
      // {
      //   title: 'Itens Checklists',
      //   route: 'list-itemchecklists',
      //   perfil_id: [1],
      // },
    ],
  },
  {
    title: 'Executar Checklists',
    route: 'list-checklists',
    icon: 'LinkIcon',
    perfil_id: [1, 2, 6, 7],
  },
  {
    title: 'Histórico de Checklists',
    route: 'list-checklist-executions',
    icon: 'ClockIcon',
    perfil_id: [1, 2, 6, 7],
  },
]
